<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
  </div>
}

  @if (!showFormLoader) {
<div class="form-horizontal">
    @if (gridData.length > 0) {
<div style="overflow-x: auto;">
      <table class="table table-bordered table-striped table-condensed custom-table">
        <thead>
          <tr>
            @for (header of gridHeaders; track $index) {
<th class="text-center">
              {{header.label}}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (row of gridData; track $index) {
<tr>
            @for (header of gridHeaders; track $index) {
<td
                [ngClass]="{'text-right': header.col_class === 'right-align', 'text-center': header.header_class === 'center-align'}">
              {{row[header.map]}}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>
}
    @if (gridData.length === 0) {
<div class="text-center" style="padding: 20px;">
      <p>No data available.</p>
    </div>
}
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
